/* eslint-disable no-console */
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import './index.css';
import App from './App';
import '@nike/ruxac/fonts';
import '@nike/ruxac/styles';
import './Styles/styles.scss';
import 'normalize.css/normalize.css';
import configureStore from './Store/configureStore';
import registerServiceWorker from './registerServiceWorker';


const store = configureStore();

const AppJsx = (
    <Provider store={store}  >
        <App />
    </Provider>
);
ReactDOM.render(AppJsx, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js